import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { Pagination, Space, Table, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import ConfirmationModal from "../modal/ConfirmationModal";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function TargetApprovalsTable(props) {
  const [rejectModal, setRejectModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [approvalId, setApprovalId] = useState("");
  const [approvalAction, setApprovalAction] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(props.tableLoading);
  }, [props.tableLoading]);

  function getStatusColor(status) {
    let color = "";
    if (status === "Pending") {
      color = "orange";
    } else if (status === "Approved") {
      color = "green";
    } else {
      color = "red";
    }
    return color;
  }

  const columns = [
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
      render: (text, record) => (
        <Tooltip placement="topLeft" title={record?.plan?.title}>
          {record?.plan?.title}
        </Tooltip>
      ),
      ellipsis: true,
      fixed: "left",
      width: 300,
    },
    {
      title: "Plan Level",
      dataIndex: "planLevel",
      key: "planLevel",
      render: (text, record) => (
        <div>{record?.plan?.planLevel?.title || "-"}</div>
      ),
    },
    {
      title: "Parent Plan",
      dataIndex: "parentPlan",
      key: "parentPlan",
      render: (text, record) => (
        <div>
          {record.plan?.cascadeFrom?.id ? (
            <Tooltip
              placement="topLeft"
              title={record.plan?.cascadeFrom?.title}
            >
              {record.plan?.cascadeFrom?.title}
            </Tooltip>
          ) : record.plan?.splitFrom?.id ? (
            <Tooltip placement="topLeft" title={record.plan?.splitFrom?.title}>
              {record.plan?.splitFrom?.title}
            </Tooltip>
          ) : (
            "-"
          )}
        </div>
      ),
      ellipsis: true,
      width: 300,
    },
    {
      title: "Achieved",
      dataIndex: "archivedTarget",
      key: "archivedTarget",
      render: (text, record) => (
        <div>
          {record.archivedTarget} / {record.target}
        </div>
      ),
    },
    {
      title: "Added by",
      dataIndex: "addedBy",
      key: "addedBy",
      render: (text, record) => <div>{record.position?.fullName}</div>,
    },
    {
      title: "Added on",
      dataIndex: "addedOn",
      key: "addedOn",
      render: (text, record) => <div>{record.updatedOn?.slice(0, 10)}</div>,
    },
    {
      title: "Status",
      key: "approvalStatus",
      dataIndex: "approvalStatus",
      render: (text) => (
        <Tag color={getStatusColor(text)}>{text?.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          {record.approvalStatus === "Pending" && (
            <>
              <Tooltip title={"Approve"}>
                <div
                  onClick={() => {
                    setApproveModal(true);
                    setApprovalId(record.progressId);
                    setApprovalAction("Approved");
                  }}
                  className="text-green-500 hover:text-green-600 cursor-pointer"
                >
                  <CheckCircleOutlined />
                </div>
              </Tooltip>
              <Tooltip title={"Reject"}>
                <div
                  onClick={() => {
                    setRejectModal(true);
                    setApprovalId(record.progressId);
                    setApprovalAction("Rejected");
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <CloseCircleOutlined />
                </div>
              </Tooltip>
            </>
          )}
        </Space>
      ),
      fixed: "right",
      width: 90,
    },
  ];
  return (
    <>
      <>
        <Table
          pagination={false}
          loading={loading}
          columns={columns}
          dataSource={props.data}
          scroll={{ x: 1300 }}
        />
        <div className="text-center mt-6">
          <Pagination
            onChange={(num) => {
              props.changePage(num);
              props.setPage(num);
            }}
            current={props.current}
            total={props.data?.totalCount || 0}
            pageSize={LIMIT_PER_PAGE}
          />
        </div>
      </>

      <ConfirmationModal
        visible={rejectModal}
        handleCancel={() => {
          setRejectModal(false);
          setApprovalId("");
          setApprovalAction("");
        }}
        text="Are you sure want to reject this?"
        title="Reject approval"
        handleOk={() => props.rejectApproval(approvalId, approvalAction, "all")}
      />
      <ConfirmationModal
        visible={approveModal}
        handleCancel={() => {
          setApproveModal(false);
          setApprovalId("");
          setApprovalAction("");
        }}
        text="Are you sure want to approve this?"
        title="Approve approval"
        handleOk={() =>
          props.approveApproval(approvalId, approvalAction, "all")
        }
      />
    </>
  );
}

export default TargetApprovalsTable;
